import axios from 'axios'
import {
  DocumentDetail,
  DocumentListItem,
  InsuranceFields,
  OcrField,
  OcrProcessingResult,
  SpecimenItem,
  WorkflowStatus,
} from '../types'
import config from '../config'

export type PersistedOcrResult = OcrProcessingResult & { documentId: string }

export type UpdateDocumentPayload = {
  mappedFields?: Record<string, OcrField>
  specimens?: SpecimenItem[]
  insurance?: InsuranceFields
  status?: WorkflowStatus
}

export const processDocument = async (file: File): Promise<PersistedOcrResult> => {
  const formData = new FormData()
  formData.append('document', file)

  const response = await axios.post<PersistedOcrResult>(
    `${config.apiUrl}/ocr/process`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )

  return response.data
}

export const listDocuments = async (): Promise<DocumentListItem[]> => {
  const response = await axios.get<{ documents: DocumentListItem[] }>(
    `${config.apiUrl}/documents`
  )
  return response.data.documents
}

export const getDocument = async (id: string): Promise<DocumentDetail> => {
  const response = await axios.get<DocumentDetail>(
    `${config.apiUrl}/documents/${id}`
  )
  return response.data
}

export const getDocumentFileUrl = (id: string): string =>
  `${config.apiUrl}/documents/${id}/file`

export const updateDocument = async (
  id: string,
  payload: UpdateDocumentPayload
): Promise<DocumentDetail> => {
  const response = await axios.patch<DocumentDetail>(
    `${config.apiUrl}/documents/${id}`,
    payload
  )
  return response.data
}
